module.exports = __webpack_public_path__ + "img/step1-no.f5c957ca.png";